import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';


export const authGuard: CanActivateFn = (route, state) => {  
  const userService = inject(UserService);
  const router = inject(Router);

  return new Promise((resolve, reject) => {
    userService.getUserDetails().subscribe(value => {
      let user = JSON.parse(localStorage.getItem('CSIPUser') || '{}');
      if (value != undefined && Object.keys(value).length > 0 || Object.keys(user).length > 0) {
        resolve(true);
      } else {
        router.navigate(['/'])
        resolve(false);
      }
    })
  })
};
